import React from 'react';

const Badminton = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 24 24'
            className={className}
        >
            <g clip-path='url(#clip0_14545_80173)'>
                <path d='M5.79896 15.0952L7.98975 17.2938L10.7888 20.094L8.30671 22.5761C6.40819 24.4746 3.32397 24.4746 1.4263 22.5761C0.473375 21.623 3.89244e-05 20.3858 0 19.1319C0 17.8951 0.472328 16.641 1.4263 15.6956L3.90838 13.2135L5.79896 15.0952ZM23.3554 9.44234C23.742 9.49377 24.0248 9.83823 23.9983 10.2325L23.8018 12.8608C23.7847 13.1274 23.6301 13.3513 23.3978 13.4713L11.8479 19.3328L9.91493 17.3987L20.3064 9.04726L23.3554 9.44234ZM18.571 4.71696C18.9574 4.73409 19.2667 5.04376 19.2841 5.43012L19.3868 8.12763L8.99531 16.4791L7.51767 15.0025L15.8657 4.61428L18.571 4.71696ZM13.7697 0.00161831C14.1561 -0.0240845 14.5082 0.259273 14.5599 0.645583L14.955 3.69577L6.60474 14.0874L4.67064 12.1544L10.531 0.603173C10.6433 0.370952 10.8746 0.2163 11.1325 0.19916L13.7697 0.00161831Z' />
            </g>
        </svg>
    );
};

export default Badminton;
